import { render, staticRenderFns } from "./prpCategory.vue?vue&type=template&id=4c637926"
import script from "./prpCategory.vue?vue&type=script&lang=js"
export * from "./prpCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports